<template>
  <div id="app">
    <div class="app-pc-header" v-if="!isMobile">
      <div class="app-pc-header-content">
        <div class="app-pc-header-logo">
          <img src="@/assets/images/common/logo.png" alt="" />
        </div>
        <div class="app-pc-header-menu">
          <div
            class="app-pc-header-menu-item"
            @click="handleJumpToHomeIndex"
          >首页</div>
          <div
            class="app-pc-header-menu-item"
            :class="{
              active: routerName && routerName === 'CommonIndexRankingSteady'
            }"
            @click="handleJumpToRankingSteady"
          >稳健投资</div>
          <div
            class="app-pc-header-menu-item"
            :class="{
              active: routerName && routerName === 'CommonIndexRankingAdvance'
            }"
            @click="handleJumpToRankingAdvance"
          >进阶投资</div>
          <div
            class="app-pc-header-menu-item"
            :class="{
              active: routerName && routerName === 'newFundList'
            }"
            @click="handleJumpToNewFundList"
          >新发基金</div>
          <div
            class="app-pc-header-menu-item"
            :class="{
              active: routerName && routerName === 'HomeRankingList'
            }"
            @click="handleJumpToRankingList"
          >复购排行</div>
          <div
            class="app-pc-header-menu-item"
            :class="{
              active: routerName && routerName === 'CommonBulletin'
            }"
            @click="handleJumpToCommonBulletin"
          >公告</div>
        </div>
        <div class="app-pc-header-down">
          <img src="@/assets/images/pc/header_icon_download.png" alt="" class="app-pc-header-down-icon" />
          <div class="app-pc-header-down-text">下载APP</div>
          <div class="app-pc-header-down-popover">
            <i class="app-pc-header-down-popover-arrow"></i>
            <div class="app-pc-header-down-dialog">
              <div>
                <img src="@/assets/images/pc/qr.png" alt="" class="app-pc-header-down-dialog-qr" />
              </div>
              <div class="app-pc-header-down-dialog-txt">扫一扫下载普泽APP</div>
            </div>
          </div>
        </div>
        <div v-if="customerDetail && customerDetail.customerNo" class="app-pc-header-login">
          <img src="@/assets/images/pc/header_icon_member.png" alt="" class="app-pc-header-down-icon" />
          <div class="app-pc-header-login-text">{{ customerDetail.mobile }}</div>
          <img src="@/assets/images/pc/arrow-down.png" alt="" class="app-pc-header-login-icon2">
          <div class="app-pc-header-down-dropdown">
            <div>
              <i class="app-pc-header-down-dropdown-arrow"></i>
              <div class="app-pc-header-down-dropdown-main">
                <div @click="handleToLoginOut" class="app-pc-header-down-dropdown-main-btn">退出登录</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else @click="handleToLoginIn" class="app-pc-header-login">
          <img src="@/assets/images/pc/header_icon_member.png" alt="" class="app-pc-header-down-icon" />
          <div class="app-pc-header-login-text">去登录</div>
        </div>
      </div>
    </div>
    <div class="app-content">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <!-- <migration-dialog /> -->
      <van-dialog
        v-model="showOutMan"
        title="提示"
        message="您提交实名认证正在审核，审核结果会通过在线消息的形式发送给您，请等待有审核结果后再试。"
        :show-cancel-button="false"
        :close-on-click-overlay="false"
        :close-on-click-action="false"
        @confirm="handleClose"
      >
      </van-dialog>
    </div>
    <div class="app-pc-footer" v-if="!isMobile">
      <div class="app-pc-footer-notice">
        <a href="/pc-web/sales-qualification.html" target="_blank" class="app-pc-footer-notice-item">基金销售资质</a>
        <span class="app-pc-footer-notice-item-zw"></span>
        <a href="/pc-web/investor-rights.html" target="_blank" class="app-pc-footer-notice-item">投资者权益须知</a>
        <span class="app-pc-footer-notice-item-zw"></span>
        <a href="/pc-web/risk-letter.html" target="_blank" class="app-pc-footer-notice-item">风险提示函</a>
        <span class="app-pc-footer-notice-item-zw"></span>
        <a href="/pc-web/safe-tips.html" target="_blank" class="app-pc-footer-notice-item">安全提示</a>
        <span class="app-pc-footer-notice-item-zw"></span>
        <a href="/pc-web/disclaimer.html" target="_blank" class="app-pc-footer-notice-item">免责声明</a>
        <span class="app-pc-footer-notice-item-zw"></span>
        <a href="/pc-web/anti-notice.html" target="_blank" class="app-pc-footer-notice-item">反洗钱专栏</a>
        <span class="app-pc-footer-notice-item-zw"></span>
        <a href="/pc-web/risk-appraisal.html" target="_blank" class="app-pc-footer-notice-item">投资者风险承受能力评价方法</a>
        <span class="app-pc-footer-notice-item-zw"></span>
        <a href="/pc-web/risk-level.html" target="_blank" class="app-pc-footer-notice-item">风险评级制度</a>
        <span class="app-pc-footer-notice-item-zw"></span>
        <a href="/pc-web/appro-notice.html" target="_blank" class="app-pc-footer-notice-item">适当性匹配须知</a>
        <span class="app-pc-footer-notice-item-zw"></span>
        <a class="app-pc-footer-notice-item" @click="handleShowSuggestDialog">投诉建议</a>
        <span class="app-pc-footer-notice-item-zw"></span>
        <a href="https://gs.amac.org.cn/amac-infodisc/res/pof/person/personList.html?userId=1903291907100018" target="_blank" class="app-pc-footer-notice-item">从业人员查询</a>
      </div>
      <div class="app-pc-footer-service">
        <div class="app-pc-footer-service-item">普泽基金客服热线：400-6099-200</div>
        <div class="app-pc-footer-service-item">服务时间：工作日  09:00-18:00</div>
        <div class="app-pc-footer-service-item">客服邮箱：vip@puzefund.com</div>
      </div>
      <div class="app-pc-footer-zw"></div>
      <div class="app-pc-footer-tips">京ICP备18012681号-2  版权所有 Copyright©2012-2024宜信普泽(北京)基金销售有限公司</div>
    </div>
    <div class="app-pc-fixbtn" v-if="!isMobile">
      <img src="@/assets/images/pc/app-pc-down-btn.jpg" alt="" class="app-pc-fixbtn-img" />
      <div class="app-pc-fixbtn-dialog">
        <img src="@/assets/images/pc/app-pc-qr2.png" alt="" class="app-pc-fixbtn-dialog-img" />
      </div>
    </div>
    <div v-if="showAppPcComplainDialog && !isMobile" class="app-pc-complain-mask">
      <div class="app-pc-complain-container">
        <div class="app-pc-complain-title">投诉建议</div>
        <div class="close-btn" @click="handleHideSuggestDialog">
          <img src="@/assets/images/icon_close.png" alt="关闭" />
        </div>
        <div class="app-pc-complain-content">
          <p>若您在使用过程中遇到任何不便，或者有需要改进的功能和需求可与客服人员联系，留下您宝贵的意见和建议。</p>
          <p>客服服务热线：400-6099-200 </p>
          <p>服务时间：工作日 09:00-18:00   </p>
          <p>客服邮箱：vip@puzefund.com</p>
        </div>
        <div class="app-pc-complain-btn" @click="handleHideSuggestDialog">知道了</div>
        <a href="javascript:;" @click="viewflow" class="view-flow-link">查看处理流程 >></a>
      </div>
    </div>
    <div v-if="showFlowDialog" class="custom-dialog" @click="closeDialog">
      <div class="dialog-content">
        <div class="close-btn" @click.stop="closeDialog">
          <img src="@/assets/images/icon_close.png" alt="关闭" />
        </div>
        <img src="@/assets/images/flow.jpg" alt="处理流程" style="width: 100%;">
      </div>
    </div>
  </div>
</template>

<script>
import { setTemplateColors, getChannelCode, isMobile } from '@/utils/utils.js'
import {
  getCustomerDetail,
  basicGetBasicConfig,
  noticeGetInfo,
  fetchDictBizDictionary,
  postAccountLoginout
} from '@/api'
import {
  initSensors,
  setSensorsLogin
} from '@/utils/tools.js'
import {
  isInPZAPP,
  pzLoginOut,
  pzOpenNativePage
} from '@/utils/bridge'

// import MigrationDialog from '@/components/migration-dialog.vue'

export default {
  data () {
    return {
      isMobile: isMobile(),
      channelCode: this.$route.query.channelCode,
      showMigrationDialog: true,
      showFlowDialog: false,
      showOutMan: false,
      showAppPcComplainDialog: false
    }
  },
  computed: {
    colors () {
      return this.$store.state.themeColors
    },
    customerDetail () {
      return this.$store.state.customerDetail
    },
    showOutManDialog () {
      return this.$store.getters.showOutManDialog
    },
    routerName () {
      return this.$route.name
    }
  },
  components: {
    // MigrationDialog
  },
  watch: {
    colors () {
      this.initTemplate()
    },
    customerDetail () {
      if (this.customerDetail.customerNo) {
        setSensorsLogin(this.customerDetail.customerNo)
      }
    },
    showOutManDialog: {
      handler (val) {
        this.showOutMan = val
      },
      immediate: true
    }
  },
  mounted () {
    if (!this.channelCode) {
      const channelCode = getChannelCode()
      this.channelCode = channelCode
      this.setChannelCodeInLocalStorage(channelCode)
    }
    this.initTemplate()
    this.initCustom()
    this.initBasicConfig()
    this.initDividendFundType()
    this.fetchNotice()
    initSensors(this.channelCode)
  },
  methods: {
    viewflow () {
      this.showFlowDialog = true
    },
    closeDialog () {
      this.showFlowDialog = false
    },
    handleShowSuggestDialog () {
      this.showAppPcComplainDialog = true
    },
    handleHideSuggestDialog () {
      this.showAppPcComplainDialog = false
    },
    handleToLoginIn () {
      if (isInPZAPP) {
        pzOpenNativePage({
          page: '/login_page'
        })
      } else {
        this.$router.push({
          name: 'AccountLogin',
          query: {
            targetUrl: encodeURIComponent(window.location.href)
          }
        })
      }
    },
    handleToLoginOut () {
      this.$dialog.confirm({
        title: '提示',
        message: '您确定要退出登录吗？'
      }).then(() => {
        if (isInPZAPP) {
          pzLoginOut()
        } else {
          postAccountLoginout().then((res) => {
            if (res && res.code === 200) {
              this.$store.dispatch('updateCustomerDetail', {})
              this.$toast('退出登录成功')
              setTimeout(() => {
                window.location.reload()
              }, 1000)
            } else {
              this.$toast(res.msg)
            }
          })
        }
      }).catch(() => {})
    },
    handleJumpToHomeIndex: function () {
      window.location.href = '/pc-web/index.html'
    },
    handleJumpToRankingSteady: function () {
      window.location.href = '/ranking-steady'
    },
    handleJumpToRankingAdvance: function () {
      window.location.href = '/ranking-advance'
    },
    handleJumpToNewFundList: function () {
      window.location.href = '/new-fund-list'
    },
    handleJumpToRankingList: function () {
      window.location.href = '/ranking-list'
    },
    handleJumpToCommonBulletin: function () {
      window.location.href = '/common/bulletin'
    },
    handleClose () {
      this.$store.dispatch('updateShowOutManDialog', false)
    },
    initTemplate () {
      setTemplateColors(this.colors)
    },
    initCustom () {
      getCustomerDetail().then((res) => {
        if (res.code === 200) {
          const data = res.data || {}
          data.customerName = data.customerName || '新用户'
          this.$store.dispatch('updateCustomerDetail', data)
        }
      })
    },
    initBasicConfig () {
      basicGetBasicConfig().then((res) => {
        if (res.code === 200) {
          const _data = res.data || {}
          const _themesColors = {
            ...this.$store.state.themeColors,
            theme: _data.themeColor || '#BA9566'
          }
          this.$store.dispatch('updateBasicConfig', _data)
          this.$store.dispatch('updateThemeColors', _themesColors)
        }
      })
    },
    initDividendFundType () {
      fetchDictBizDictionary({ code: 'dividend_fund_type' }).then((res) => {
        const _data = res.data || []
        this.$store.dispatch('updateDividendFundType', _data)
      })
    },
    setChannelCodeInLocalStorage (channelCode) {
      try {
        window.sessionStorage.setItem('channelCode', channelCode || '001')
      } catch (e) {}
    },
    fetchNotice () {
      noticeGetInfo({
        displayRange: 1
      }).then((res) => {
        if (res && res.code === 200) {
          if (res.data.bulTitle) {
            this.$dialog.alert({
              title: res.data.bulTitle || '',
              message: res.data.bulContent || ''
            })
          }
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
#app {
  width: 100%;
  height: 100%;
  position: relative;
  background: var(--primary-background-color);
  display: flex;
  flex-direction: column;
  .app-content {
    flex: 1;
    min-height: 100vh;
    position: relative;
  }
}
.dialog-content {
  position: relative;
  width: 90%;
  max-width: 600px;
  background: #fff;
  border-radius: 8px;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.custom-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.view-flow-link {
  display: block;
  text-align: center;
  color: #3A64D8;
  margin-top: 12px;
  font-size: 0.83333vw;
  text-decoration: none;
}
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  z-index: 10;
}
.close-btn img {
  width: 100%;
  height: 100%;
}
.app-pc-complain-container {
  position: relative;
}
.app-pc-complain-mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 101;
    display: flex
;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.6);
}
</style>
